import React from 'react';
import PortalJobScheduler
  from '../job-scheduling/portal-job-scheduler.jsx';
import SingleJobMapWithGeolocations
  from '../maps/single-job-map-with-geolocations.jsx';
import JobFullDetailsTabNavigation
  from './job-full-details/job-full-details-tab-navigation.jsx';
import JobFullDetailsMainDetails
  from './job-full-details/job-full-details-main-details.jsx';
import JobFullDetailsAppraisal
  from './job-full-details/job-full-details-appraisal.jsx';
import JobFullDetailsFleetPaperwork
  from './job-full-details/job-full-details-fleet-paperwork.jsx';
import JobFullDetailsExpenses
  from './job-full-details/job-full-details-expenses.jsx';
import JobFullDetailsInvoice
  from './job-full-details/job-full-details-invoice.jsx';
import JobFullDetailsJobNotifications
  from './job-full-details/job-full-details-job-notifications.jsx';
import JobFullDetailsDriverMessages
  from './job-full-details/job-full-details-driver-messages.jsx';
import JobFullDetailsDriverDocuments
  from './job-full-details/job-full-details-driver-documents.jsx';
import JobFullDetailsTools
  from './job-full-details/job-full-details-tools.jsx';  
import JobFullDetailsCallDetails
  from './job-full-details/job-full-details-call-details.jsx';
import { Animate } from 'react-simple-animate';

export default class JobFullDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      appraisal_data: null,
      expenses_data: null,
      expense_approval_data: {},
      isLoadingAppraisalInfo: true,
      data: this.props.data || {},
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      showJobScheduler: false,
      showAddExpenseForm: false,
      play: false,
      customerAllJobsPage:this.props.customerAllJobsPage || false
    };
    this.handleJobScheduling = this.handleJobScheduling.bind(this);
    this.handleSchedulerHide = this.handleSchedulerHide.bind(this);
    Echo.channel('jobs-table-'+this.state.data.id).listen(
      'AppraisalInfoChanged',
      (e) => {
        this.getAppraisalInfo();
      }
    );
    this.handleSchedulerHide = this.
    handleSchedulerHide.bind(this);
  }
  handleSchedulerHide(){ 
    this.setState({showJobScheduler: false});
  }
  componentWillReceiveProps(nextProps) {
    this.setState({data: nextProps.data,customerAllJobsPage:nextProps.customerAllJobsPage});
  }
  componentDidMount() {
    this.getAppraisalInfo();
    this.setState({
      play: true
    });
  }
  getAppraisalInfo() {
    let url = '/api/v1/portal/appraisal-info/'+this.state.data.id;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((appraisalInfoJson) => {
        this.setState({
          appraisal_data: appraisalInfoJson,
          isLoadingAppraisalInfo: false
        })
      });
    });
  }
  handleJobScheduling() {
    this.setState({showJobScheduler: !this.state.showJobScheduler});
  }
  render() {
    let geoLocationData = {
      pickupAddress: this.state.data.pickup_address,
      dropoffAddress: this.state.data.dropoff_address,
      jobId: this.state.data.id
    };
    let jobId = this.state.data.id;
    if (this.state.data.subcontracted_parent_job_id === null &&
      this.state.data.subcontracted_job_id !== null) {
      jobId = this.state.data.subcontracted_job_id;
    }
    return (
      <Animate
        play={this.state.play}
        start={{opacity: 0}}
        end={{opacity: 1}}
      >
        <div
          className="jobs-table-row job-full-details"
          id={"job-full-details-"+this.state.data.id}
          key={"job-full-details-"+this.state.data.id}
        >{this.state.showJobScheduler ?
          <div className="job-scheduler-container">
            <button
              className="btn btn-lg btn-danger close-job-scheduler-button"
              onClick={(e) => {
                this.setState({
                  showJobScheduler: !this.state.showJobScheduler
                });
              }}>-</button>
          <PortalJobScheduler
            jobId={this.state.data.id}
            data={this.state.data}
            isLoading={false}
            schedulerHide={this.handleSchedulerHide}
          />
          </div> : null}
          <div className="row">
            <div className="col-md-3 col-sm-6">
              <div className="google-map">
                <SingleJobMapWithGeolocations data={geoLocationData} />
              </div>
            </div>
            <div className="col-md-9">
              <JobFullDetailsTabNavigation jobId={this.state.data.id} customerAllJobsPage={this.state.customerAllJobsPage}/>
              <div className="tab-content-container">
                <div className="tab-content">
                  <div className="tab-pane active fade in show"
                    id={"job-"+this.state.data.id+"-main-details"}>
                    <JobFullDetailsMainDetails
                      data={this.state.data}
                      customerAllJobsPage={this.state.customerAllJobsPage}
                    />
                  </div>
                  <div className="tab-pane fade"
                    id={"job-"+this.state.data.id+"-pickup-appraisal"}>
                    <h3>Pickup Appraisal for Job {this.state.data.id}</h3>
                    <JobFullDetailsAppraisal
                      data={this.state.data}
                      appraisal_data={this.state.appraisal_data}
                      isLoadingAppraisalInfo={this.state.isLoadingAppraisalInfo}
                      type='pickup'
                    />
                  </div>
                  <div className="tab-pane fade"
                    id={"job-"+this.state.data.id+"-dropoff-appraisal"}>
                    <h3>Dropoff Appraisal for Job {this.state.data.id}</h3>
                    <JobFullDetailsAppraisal
                      data={this.state.data}
                      appraisal_data={this.state.appraisal_data}
                      isLoadingAppraisalInfo={this.state.isLoadingAppraisalInfo}
                      type='dropoff'
                    />
                  </div>
                  <div className="tab-pane fade"
                    id={"job-"+this.state.data.id+'-paperwork'}>
                    <JobFullDetailsFleetPaperwork
                      data={this.state.data}
                      appraisal_data={this.state.appraisal_data}
                      jobId={jobId}
                    />
                  </div>
                  <div className="tab-pane fade"
                    id={"job-"+this.state.data.id+"-expenses"}>
                    <h3>Expenses</h3>
                    <JobFullDetailsExpenses
                      data={this.state.data}
                      jobId={jobId}
                    />
                  </div>
                  <div className="tab-pane fade"
                    id={"job-"+this.state.data.id+"-invoice"}>
                    <h3>Invoice for Job {this.state.data.id}</h3>
                    <JobFullDetailsInvoice
                      data={this.state.data}
                    />
                  </div>
                  <div className="tab-pane fade"
                    id={"job-"+this.state.data.id+"-notifications"}>
                    <h3>Notifications</h3>
                    <JobFullDetailsJobNotifications
                      data={this.state.data}
                    />
                  </div>
                  <div className="tab-pane fade"
                    id={"job-"+this.state.data.id+"-driver-messages"}>
                    <h3>Driver Messages</h3>
                    <JobFullDetailsDriverMessages
                      data={this.state.data}
                    />
                  </div>
                  <div className="tab-pane fade"
                    id={"job-"+this.state.data.id+"-driver-documents"}>
                    <h3>Driver Documents</h3>
                    <JobFullDetailsDriverDocuments
                      data={this.state.data}
                    />
                  </div>
                  <div className="tab-pane fade"
                    id={"job-"+this.state.data.id+"-tools"}>
                    <h3>Tools</h3>
                    <JobFullDetailsTools
                      data={this.state.data}
                      hasSplitParent={this.props.hasSplitParent}
                      isSplitJob={this.props.isSplitJob}
                      hasSplitJobs={this.props.hasSplitJobs}
                      isSplitJobPartA={this.props.isSplitJobPartA}
                      isSplitJobPartB={this.props.isSplitJobPartB}
                    />
                  </div>
                  <div className="tab-pane fade"
                    id={"job-"+this.state.data.id+"-settings"}>
                    <h3>Settings</h3>
                    <PortalJobScheduler
                      data={this.state.data}
                      jobId={this.state.data.id}
                      schedulerHide={this.handleSchedulerHide}
                    />
                  </div>
                  <div className="tab-pane fade"
                    id={"job-"+this.state.data.id+"-call-informations"}>
                    <h3>Call Details for Job {this.state.data.id}</h3>
                    <JobFullDetailsCallDetails
                      data={this.state.data}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Animate>
    )
  }
}
